export const GET_PROJECT_DETAILS_START = 'GET_PROJECT_DETAILS_START';
export const GET_PROJECT_DETAILS_REQUEST = 'GET_PROJECT_DETAILS_REQUEST';
export const GET_PROJECT_DETAILS_SUCCESS = 'GET_PROJECT_DETAILS_SUCCESS';
export const GET_PROJECT_DETAILS_FAILURE = 'GET_PROJECT_DETAILS_FAILURE';

export const RESET_PROFILE = 'RESET_PROFILE';
